import React, {useEffect} from "react";
import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";
import { useTwoStepAuthSet } from "@/features/two-step-authentication/hooks/use-two-step-authentication-set";

interface Props {
	onCloseModal: () => void;
  isValid: boolean;
}

export const TwoStepAuthSetCompleteModal = ({ onCloseModal, isValid }: Props) => {
  
	return (
		<BasePageModal
      title="2段階認証の設定"
      handleClose={onCloseModal}
      className="md-user-2factor"
    >
			<h2>2段階認証を{isValid ? "有効に" : "解除"}しました。</h2>
      <div className="message">
        {isValid ? (
          <>
            <p>2段階認証の設定が完了しました。</p>
            <p>今後は認証コードによる追加のセキュリティが適用されます。</p>
            <p>より安全にご利用いただけます。</p>
          </>
        ) : (
          <>
            <p>2段階認証が無効になりました。</p>
            <p>今後ログイン時の確認コード入力は不要となります。</p>
            <p>セキュリティ向上のため、必要に応じて再度有効化をご検討ください。</p>
          </>
        )}
      </div>
		</BasePageModal>
	);
};